export const isLandingOnlyModeEnabled =
  process.env.NEXT_PUBLIC_LANDING_ONLY_MODE === "true";
